import ModelUtil from '@leverege/model-util';
import { Attributes, DetailModel } from '@leverege/ui-attributes';
import ImageDetailModel from "../models/ImageDetailModel.js";
/* Initialize Constants */
const VALUE_TYPE = 'resourceImage';
const TYPE = `attr.detail.${VALUE_TYPE}`;

/**
 * Gets name from data.
 */
function getName(data) {
  return Attributes.getDisplayName(data.attrName, data.objectType);
}

/* Initialize Model Base */
const base = {
  ...ImageDetailModel,
  getName,
  ...ModelUtil.createAllValue('formatter')
};
delete base.create;
delete base.TYPE;

/**
 * Creates an attribute detail model instance.
 */
function create(attrName, objectType) {
  const mdl = DetailModel.create(TYPE, {
    attrName,
    objectType,
    ...structuredClone(ImageDetailModel.dModel)
  });
  mdl.label.align = 'top';
  return mdl;
}

/* Export Modules */
export default {
  TYPE,
  create,
  ...base
};